<payee-header>
  <ng-template #logoTemplate>
    <a [href]="payeeLink">
      <img
        alt=""
        src="assets/shared/global-images/payee-logos/v1/black-payee-with-badge.svg"
        width="100px"
      />
    </a>
  </ng-template>
  <ng-template #payeeHeaderLogoTemplate>
    <ng-container [ngTemplateOutlet]="logoTemplateRef || logoTemplate"></ng-container>
  </ng-template>
  <ng-content></ng-content>
  <ng-template #payeeHeaderButtonTemplate>
    <div class="buttons flex vcenter">
      <button
        payee-icon-button
        color="white"
        class="logout"
        [isBorderButton]="true"
        (click)="logout()"
      >
        <payee-icon name="logout-grey"></payee-icon>
      </button>
      <a
        payee-header-button
        class="flex"
        [routerLink]="xLink"
        (click)="onXClicked()"
      >
        <img
          src="assets/shared/global-images/icon-set/cross-black.svg"
          alt="X"
        />
      </a>
    </div>
  </ng-template>
</payee-header>
